'use client';

import React from 'react';
import { ConnectionState, type PusherContextValues } from './socket-types';

// context setup
export const PusherContext = React.createContext<PusherContextValues>({
  state: ConnectionState.INIT,
});
